mutation CompleteAEMasterTemplate(
    $initialTemplateId: ID!
    $clientId: ID!
    $plainlyProjectId: String!
    $compositions: [InputAEComposition]!
) {
    completeAEMasterTemplates(
        initialTemplateId: $initialTemplateId
        clientId: $clientId
        plainlyProjectId: $plainlyProjectId
        compositions: $compositions
    ) {
        _id
    }
}
